import { clsx } from 'clsx'
import { Link, useRoute } from 'wouter-preact'
import { type ComponentChildren } from 'preact'

import { Typography } from 'components/UI/atoms'

interface Props {
	href: string
	hrefNewTab?: string
	icon: ComponentChildren
	iconRight?: ComponentChildren
	isActive: boolean
	onIconRightClick?: () => void
	title: string
}

// TODO: It's possible to refactor this component like packages/web/src/components/UI/molecules/dropdown/DropdownItem.tsx
const SidebarItem = ({
	href,
	hrefNewTab,
	icon,
	iconRight,
	isActive,
	onIconRightClick,
	title
}: Props) => {
	const [match] = useRoute('/smart-contract/:dAppName/workspace')

	if (match && hrefNewTab) {
		return (
			<li>
				<a
					class={clsx(
						'group mx-2.5 flex h-10 flex-1 items-center gap-2 rounded px-2.5 text-black-200 hover:bg-black-800 hover:text-black-100',
						isActive && 'bg-black-800 text-product hover:text-product'
					)}
					href={hrefNewTab}
					rel='noopener noreferrer'
					target='_blank'
				>
					{icon}
					<Typography
						class='cursor-pointer'
						color={
							isActive
								? 'text-black-100'
								: 'text-black-200 group-hover:text-black-100'
						}
						text={title}
						variant='label1'
						weight='font-normal'
					/>
				</a>
			</li>
		)
	}

	return (
		<li class='group relative'>
			<Link
				aria-current={isActive ? 'page' : undefined}
				class={clsx(
					'group:hover:bg-black-800 group:hover:text-black-100 group mx-2.5 flex h-10 flex-1 items-center gap-2 rounded px-2.5 py-2 text-black-200  hover:bg-black-800 hover:text-black-100',
					isActive && 'bg-black-800 text-product hover:text-product'
				)}
				href={href}
			>
				{icon}
				<Typography
					class='cursor-pointer truncate pr-6'
					color={
						isActive
							? 'text-black-100'
							: 'text-black-200 group-hover:text-black-100'
					}
					text={title}
					variant='label1'
					weight='font-normal'
				/>
			</Link>
			{iconRight && (
				<div class='absolute right-6 top-0 hidden h-full cursor-pointer items-center group-hover:flex'>
					<button
						class='z-10 h-[0.875rem] w-[0.875rem] text-product transition-opacity duration-100'
						onClick={onIconRightClick}
						type='button'
					>
						{iconRight}
					</button>
				</div>
			)}
		</li>
	)
}

export { SidebarItem }
